import React, { Component } from "react";

import ListPanel from "./Components/ListPanel";

import "../../assets/css/main.css";
import { Center, Box } from "@chakra-ui/react";

import RoleManager from "../../models/RoleManager";
import { AppSecurityKey } from "../../models/AppSecurityKey";


export default class EntityManagementPage extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }

    }


    render() {

        var hasRoleRights = RoleManager.hasRoleRights(AppSecurityKey.EDIT_ENTITIES, this.props.userSession.token);

        return (
            (hasRoleRights) ?
                <div className="main">
                    <Box bgColor='#0a597e' borderRadius='5px' width='100%' >
                        <ListPanel
                            userSession={this.props.userSession}
                            onToastRequest={this.props.onToastRequest}
                            onMsgBoxRequest={this.props.onMsgBoxRequest}
                            onErrorPageRequest={this.props.onErrorPageRequest}
                        />
                    </Box>
                </div>
                : <span />
        )
    }
}